export default [
  'error',
  'loading',
  'refetch',
  'fetchMore',
  'previousData',
  'networkStatus',
];
